import { ActivityIcon } from '@jouzen/ecom-components/icons/ActivityIcon';
import { HeartIcon } from '@jouzen/ecom-components/icons/HeartIcon';
import { HeartRangeMetricIcon } from '@jouzen/ecom-components/icons/HeartRangeMetricIcon';
import { MeditationIcon } from '@jouzen/ecom-components/icons/MeditationIcon';
import { MoonIcon } from '@jouzen/ecom-components/icons/MoonIcon';
import { ReadinessOutline } from '@jouzen/ecom-components/icons/ReadinessOutline';
import type { SVGIconComponent } from 'types/svgr';

import { type LandingPageMembershipTabData } from '@/app/components/LandingPage/LandingPageMembershipTabs/LandingPageMembershipTabContent/LandingPageMembershipTabContentCard';

const defaultMembershipTabs: LandingPageMembershipTabData[] = [
  {
    backgroundColor: 'gray',
    Icon: MoonIcon as SVGIconComponent,
    id: 'sleep',
    tab: {
      label: 'pop_membership_sleep_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_sleep_score_copy',
          image: {
            localizedAlt: 'pop_membership_sleep_score_ui_alt',
            localizedSrc: 'pop_membership_sleep_score_ui_src',
          },
          title: 'pop_membership_sleep_score_title',
        },
        {
          copy: 'pop_membership_sleep_stages_copy',
          image: {
            localizedAlt: 'sleep_and_rest_features_two_img_alt',
            localizedSrc: 'sleep_and_rest_features_two_img',
          },
          title: 'pop_membership_sleep_stages_title',
        },
        {
          copy: 'pop_membership_blood_oxygen_sensing_copy',
          image: {
            localizedAlt: 'pop_membership_blood_oxygen_sensing_ui_alt',
            localizedSrc: 'pop_membership_blood_oxygen_sensing_ui_src',
          },
          title: 'pop_membership_blood_oxygen_sensing_title',
        },
        {
          copy: 'pop_membership_bedtime_guidance_copy',
          image: {
            localizedAlt: 'pop_membership_bedtime_guidance_ui_alt',
            localizedSrc: 'pop_membership_bedtime_guidance_ui_src',
          },
          title: 'pop_membership_bedtime_guidance_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          localizedAlt: 'pop_membership_sleep_featured_or4_img_alt',
          src: 'blue-sky/pop/sleep_feature_or4',
        },
      },
    },
  },
  {
    backgroundColor: 'gray',
    Icon: ActivityIcon as SVGIconComponent,
    id: 'activity_and_fitness',
    tab: {
      label: 'pop_membership_activity_and_fitness_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'grow-1838-activity-auto-activity-desc',
          image: {
            localizedAlt: 'pop_membership_automatic_activity_detection_ui_alt',
            localizedSrc:
              'pop_membership_automatic_activity_detection_ui_v2_src',
          },
          title: 'pop_membership_automatic_activity_detection_title',
        },
        {
          copy: 'grow-1838-activity-score-desc',
          image: {
            localizedAlt: 'pop_membership_activity_score_ui_alt',
            localizedSrc: 'pop_membership_activity_score_ui_src',
          },
          title: 'pop_membership_activity_score_title',
        },
        {
          copy: 'grow-1838-personalized-activity-goals-desc',
          image: {
            localizedAlt: 'personalized_activity_goals_alt',
            localizedSrc: 'grow-1838-activity-personalized-img-src',
          },
          title: 'activity_personalized_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          localizedAlt:
            'pop_membership_activity_and_fitness_featured_or4_img_alt',
          src: 'blue-sky/pop/activity_and_fitness_feature_or4',
        },
      },
    },
  },
  {
    backgroundColor: 'gray',
    Icon: ReadinessOutline as SVGIconComponent,
    id: 'readiness',
    tab: {
      label: 'pop_membership_readiness_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_readiness_score_copy',
          image: {
            localizedAlt: 'pop_membership_readiness_score_ui_alt',
            localizedSrc: 'pop_membership_readiness_score_ui_src',
          },
          title: 'pop_membership_readiness_score_title',
        },
        {
          copy: 'pop_membership_illness_detection_copy',
          image: {
            localizedAlt: 'pop_membership_illness_detection_ui_alt',
            localizedSrc: 'pop_membership_illness_detection_ui_src',
          },
          title: 'pop_membership_illness_detection_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          localizedAlt: 'pop_membership_readiness_featured_or4_img_alt',
          src: 'blue-sky/pop/readiness_feature_or4',
        },
      },
    },
  },
  {
    backgroundColor: 'gray',
    Icon: HeartRangeMetricIcon as SVGIconComponent,
    id: 'stress',
    tab: {
      label: 'pop_membership_stress_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'grow-1838-stress-daytime-desc',
          image: {
            localizedAlt: 'pop_membership_daytime_stress_ui_alt',
            localizedSrc: 'pop_membership_daytime_stress_ui_src',
          },
          title: 'pop_membership_daytime_stress_title',
        },
        {
          copy: 'grow-1838-stress-resilience-desc',
          image: {
            localizedAlt: 'pop_membership_resilience_ui_alt',
            localizedSrc: 'pop_membership_resilience_ui_src',
          },
          title: 'pop_membership_resilience_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          localizedAlt: 'pop_membership_stress_featured_or4_img_alt',
          src: 'blue-sky/pop/stress_feature_or4',
        },
      },
    },
  },
  {
    backgroundColor: 'gray',
    Icon: HeartIcon as SVGIconComponent,
    id: 'heart_health',
    tab: {
      label: 'pop_membership_heart_health_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_24-7_heart_rate_monitoring_copy',
          image: {
            localizedAlt: 'pop_membership_24-7_heart_rate_monitoring_ui_alt',
            localizedSrc: 'pop_membership_24-7_heart_rate_monitoring_ui_src',
          },
          title: 'pop_membership_24-7_heart_rate_monitoring_title',
        },
        {
          copy: 'grow-1838-heart-health-cardio-age-desc',
          image: {
            localizedAlt: 'pop_membership_24-7_heart_rate_monitoring_ui_alt',
            localizedSrc: 'grow-1838-heart-health-cardio-age-app-ui-src',
          },
          title: 'cardiovascular-age',
        },
        {
          copy: 'grow-1838-heart-health-cardio-capacity-desc',
          image: {
            localizedAlt: 'pop_membership_24-7_heart_rate_monitoring_ui_alt',
            localizedSrc: 'grow-1838-heart-health-cardio-cap-app-ui-src',
          },
          title: 'cardio-capacity',
        },
        {
          copy: 'pop_membership_heart_rate_variability_copy',
          image: {
            localizedAlt: 'pop_membership_heart_rate_variability_ui_alt',
            localizedSrc: 'pop_membership_heart_rate_variability_ui_src',
          },
          title: 'pop_membership_heart_rate_variability_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          localizedAlt: 'pop_membership_heart_health_featured_or4_img_alt',
          src: 'blue-sky/pop/heart_health_feature_or4',
        },
      },
    },
  },
  {
    backgroundColor: 'gray',
    Icon: MeditationIcon as SVGIconComponent,
    id: 'womens_health',
    tab: {
      label: 'pop_membership_womens_health_tab_title',
    },
    tabPanel: {
      cards: [
        {
          copy: 'pop_membership_cycle_insights_copy',
          image: {
            localizedAlt: 'pop_membership_cycle_insights_ui_alt',
            localizedSrc: 'pop_membership_cycle_insights_ui_src',
          },
          title: 'pop_membership_cycle_insights_title',
        },
        {
          copy: 'fertile_window_copy',
          image: {
            localizedAlt: 'fertile_window_image_alt',
            localizedSrc: 'memberships_fertile_window_img',
          },
          title: 'fertile_window_title',
        },
        {
          copy: 'grow-1838-womens-health-period-prediction-desc',
          image: {
            localizedAlt: 'pop_membership_period_prediction_ui_alt',
            localizedSrc: 'membership_period_prediction_img',
          },
          title: 'pop_membership_period_prediction_title',
        },
        {
          copy: 'pop_membership_natural_cycles_integration_copy',
          image: {
            localizedAlt: 'pop_membership_natural_cycles_integration_ui_alt',
            localizedSrc: 'pop_membership_natural_cycles_integration_ui_src',
          },
          title: 'pop_membership_natural_cycles_integration_title',
        },
        {
          copy: 'pop_membership_partner_integrations_copy',
          image: {
            localizedAlt: 'pop_membership_partner_integrations_ui_alt',
            localizedSrc: 'pop_membership_partner_integrations_ui_src',
          },
          title: 'pop_membership_partner_integrations_title',
        },
      ],
      featuredImage: {
        backgroundImage: {
          localizedAlt: 'pop_membership_womens_health_featured_or4_img_alt',
          src: 'blue-sky/pop/womens_health_feature_or4',
        },
      },
    },
  },
] as const;

export default defaultMembershipTabs;
